module.exports = __webpack_public_path__ + "img/open-arrow.3ab7f51e.svg";